module.exports = __webpack_public_path__ + "static/media/selectedDrawHover.701de121.png";